import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect, NavLink } from "react-router-dom";
import { withFormik } from "formik";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import _ from 'lodash';
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import queryString from 'query-string';
import Button from "@material-ui/core/Button";
import { SnackbarContent, Typography, Link } from "@material-ui/core";
import { forgotPasswordRequest } from "store/state/forgotPassword";
import { validationSchema } from "shapes/forgotPassword";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  root: {
    background: "transparent"
  },
  input: {
    color: "#333",
    fontWeight: "100",
    backgroundColor: "#fff",
    fontFamily: "Roboto"
  },
  divider: {
    backgroundColor: "#fff",
    marginBottom: "10px",
    marginTop: "10px"
  },
  white: {
    color: "#fff",
    fontFamily: "Futura",
    fontWeight: "bold",
    letterSpacing: "1px",
    lineHeight: "1em"
  },
  blue: {
    color: "#0f90d0",
    fontFamily: "Futura",
    fontWeight: "bold",
    letterSpacing: "1px",
    lineHeight: "1em"
  },
  caption: {
    color: "#fff",
    fontWeight: "100",
    letterSpacing: "1px",
    fontFamily: "Roboto"
  },
  boldText: {
    fontWeight: "900"
  },
  button: {
    backgroundColor: "rgba(15, 144, 208, 1)",
    color: "#fff",
    width: "150px",
    borderRadius: "20px",
    fontFamily: "Roboto",
    "&:hover": {
      backgroundColor: "rgba(15, 144, 208, .7)"
    }
  },
  label: {
    fontFamily: "Roboto",
    color: "#fff",
    fontWeight: "100",
    letterSpacing: "1px",
    marginBottom: "5px"
  },
  font17: {
    fontSize: "17px"
  }
};

export class ForgotPassword extends Component {
  state = {
    animate: false,
    touched: false,
  };
  componentDidMount() {
    setTimeout(() => {
      this.setState({ animate: true });
    }, 500);
  }

  render() {
    const {
      classes,
      loading,      
      authentication,
      handleChange,
      handleSubmit,
      values,
      errors,
      touched,
      showForgotPasswordEmailSentToastMessage,
      location,
    } = this.props;

    const {authed, authError} = authentication;

    // if the token for change password is expired or used  
    let params = queryString.parse(location.search, {arrayFormat: 'bracket'});
    const showTokenError = params ? params.tokenExpired === "true" : false;
    
    // if the user is authenticated(fail safe for the URL changes)
    if (!loading.authentication && authed) {
      let authRedirectProps = JSON.parse(localStorage.getItem('authRedirect'));      
      let path = '/home';
      let potentialPath = _.get(authRedirectProps, 'computedMatch.url');            
      if(potentialPath){
        path = potentialPath;  
        localStorage.removeItem('authRedirect');
      }
      return <Redirect to={path} />;
    }
    return (
      <Fragment>
        <Grid className="login_Panel" container spacing={24}>
          <Grid item xs={12} className="login_PanelInner">
            <Paper
              className={`shouldAnimate ${
                this.state.animate ? "animateDownFadeIn" : ""
              }`}
            >
              <form
                onSubmit={handleSubmit}
                id="forgot_password_form"
                autoComplete="new-password"
              >
                <Grid container spacing={24}>
                  <Grid item xs={12}>
                    <Typography
                      variant="display3"
                      className={`${classes.white} robotText`}
                    >
                      DEBT.
                    </Typography>
                    <Typography
                      variant="display3"
                      className={`${classes.blue} robotText`}
                    >
                      SMARTER.
                    </Typography>
                    <Divider className={classes.divider} />
                    {/* Token expired error message */}
                    {showTokenError && (
                      <Typography
                        className={`${classes.caption} ${classes.boldText} ${classes.font17}`}
                        variant="body2"
                        gutterBottom
                      >
                        That link is invalid. Please try again.
                      </Typography>
                    )}
                    <FormControl
                      fullWidth
                      error={errors.email && touched.email}
                    >
                      <Typography variant="body1" className={classes.label}>
                        Email
                      </Typography>
                      <Input
                        variant="filled"
                        id="email"
                        className={classes.input}
                        type="text"
                        value={values.email}
                        autoComplete="off"
                        onChange={handleChange}
                        placeholder="Enter email address"
                      />
                      {/* the validation error for the email fiels */}
                      {errors.email &&
                        touched.email && (
                          <FormHelperText id="name-error-text">
                            {errors.email}
                          </FormHelperText>
                        )}
                    </FormControl>
                  </Grid>
                  {/* Send email button */}
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <Button
                        type="submit"
                        size="large"
                        className={classes.button}
                        id="sendEmailButton"
                      >
                        Send Email
                      </Button>
                    </FormControl>
                  </Grid>
                  {/* Message after send email is clicked */}
                  <Grid item xs={12}>
                    {showForgotPasswordEmailSentToastMessage && (
                      <div>
                        <SnackbarContent
                          className="snackbarContentSuccess"
                          message= "An email with instructions has been sent."
                        />
                      </div>
                    )}
                  </Grid>
                </Grid>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, forgotPassword, loading }) => ({
  authentication,
  showForgotPasswordEmailSentToastMessage: forgotPassword.showForgotPasswordEmailSentToastMessage,
  loading
});

export default compose(
  connect(
    mapStateToProps,
    { forgotPasswordRequest }
  ),
  withFormik({
    mapPropsToValues: () => ({ email: "" }),
    validationSchema,
    handleSubmit: (values, { props }) => {
      props.forgotPasswordRequest(values);
    },
    displayName: "ForgotPasswordForm"
  }),
  withStyles(styles)
)(ForgotPassword);
